"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MatchingOptionsOverlayContentModule = /** @class */ (function () {
    function MatchingOptionsOverlayContentModule() {
    }
    return MatchingOptionsOverlayContentModule;
}());
exports.MatchingOptionsOverlayContentModule = MatchingOptionsOverlayContentModule;
